import React from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import {
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  Flex,
  FlexItem
} from 'mailup-web-components'

import {
  SENDING_STATUS_QUEUECOMPLETED,
  SENDING_STATUS_QUEUEFAILED,
  SENDING_STATUS_QUEUERUNNING
} from 'Constants/index'

const RecipientsCell = ({ sent, progress, total, isPartial, status }) => {
  const intl = useIntl()

  const showProgress =
    !!progress &&
    status !== SENDING_STATUS_QUEUECOMPLETED &&
    status !== SENDING_STATUS_QUEUERUNNING &&
    status !== SENDING_STATUS_QUEUEFAILED

  return (
    <>
      <Flex flexDirection='column' rowGap='8px' padding='24px 16px'>
        <FlexItem>
          <Flex flexDirection='row' columnGap='4px'>
            <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
              {intl.formatMessage({
                id: 'Load.Schedulation.StatusSentRecipients'
              })}
            </Text>
            <Text variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
              {intl.formatNumber(sent)}{' '}
              {showProgress &&
                `(${intl.formatNumber(progress, {
                  style: 'percent',
                  maximumFractionDigits: 1
                })})`}
            </Text>
          </Flex>
        </FlexItem>
        <FlexItem>
          <Flex flexDirection='row' columnGap='4px'>
            <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
              {intl.formatMessage({
                id: isPartial
                  ? 'Load.Schedulation.StatusTotPartialRecipients'
                  : 'Load.Schedulation.StatusTotRecipients'
              })}
            </Text>
            <Text variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
              {intl.formatNumber(total)}
              {isPartial && (
                <>
                  {' '}
                  <span
                    className='e-tip-icon e-tip-icon--question'
                    data-tip={intl.formatMessage({
                      id: 'Load.Schedulation.PartialSendingTooltip'
                    })}
                  />
                </>
              )}
            </Text>
          </Flex>
        </FlexItem>
      </Flex>
    </>
  )
}

export default RecipientsCell

RecipientsCell.propTypes = {
  isPartial: PropTypes.any,
  sent: PropTypes.any,
  status: PropTypes.any,
  progress: PropTypes.any,
  total: PropTypes.any
}
